import { ISetting } from '@/types'
import { getAppHost } from '@/utils/getAppHost'

// Dynamic host detection - no hardcoded URLs needed
const HOST = getAppHost()

export const baseSettings: Partial<ISetting> = {
  app: {
    code: 'liga1play',
    title: 'L1MAX',
    description: 'Experience all the live action of the Peruvian football league with L1 MAX, the official streaming platform. Do not miss a single match of your favorite teams and players.',
    defaultLanguage: 'es',
  },
  fonts: {
    base: 'gilroy',
    display: 'barlow',
  },
  images: {
    ogImage: 'https://www.fanatiz.com/fanatiz/web/other/og-image-L1max.png',
    qrCode: '/assets/images/liga1/qr.svg',
    lottie: '/assets/lotties/clients/liga1/main/loading.json',
    favicons: {
      icon: '/assets/images/liga1/favicons/favicon.ico',
      svg: '/assets/images/liga1/favicons/icon.svg',
      apple: '/assets/images/liga1/favicons/apple-touch-icon.png',
    },
  },
  gtm: {
    id: 'GTM-WLL35HV3',
    gateway: {
      enabled: true,
    },
  },
  cmp: {
    id: '0bc5cb05f2365',
  },
  api: {
    cinematicsTag: 'liga1',
  },
  intercom: {
    enabled: true,
  },
  wsc: {
    key: 'fa3f6b9c3732425bb034d908aa2a9bb7'
  },
  youbora: {
    accountCode: 'fanatiz',
    active: false,
  },
  optimizely: {
    sdkKey: 'TGhTYhnEYoEbUxpW9qp5h',
    isActive: false,
  },
  features: {
    teamBranding: true,
  },
}

export const envOverrides: Record<string, Partial<ISetting>> = {
  development: {},
  staging: {
    api: {
      host: HOST,
      cinematicsTag: 'l1maxStaging',
    },
    youbora: {
      accountCode: 'fanatiz',
      active: true,
    },
    kushki: {
      merchantId: 'f260bbbe6fbb4acf8cb319d7c4be2639',
      inTestEnvironment: false,
    },
    dlocal: {
      publicKey: '0ee5adad-73d4-4777-aeb1-0cce7ed83bfc'
    },
    optimizely: {
      sdkKey: 'TGhTYhnEYoEbUxpW9qp5h',
      isActive: false,
    },
  },
  production: {
    api: {
      host: HOST,
      cinematicsTag: 'l1maxProd',
    },
    gtm: {
      id: 'GTM-MFG69RRD',
    },
    youbora: {
      accountCode: 'fanatiz',
      active: true,
    },
    kushki: {
      merchantId: 'f260bbbe6fbb4acf8cb319d7c4be2639',
      inTestEnvironment: false,
    },
    dlocal: {
      publicKey: '0ee5adad-73d4-4777-aeb1-0cce7ed83bfc'
    },
    optimizely: {
      sdkKey: 'TGhTYhnEYoEbUxpW9qp5h',
      isActive: true,
    },
    features: {
      teamBranding: true,
    },
  },
}